import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { CommentContext } from '../../CommentContext';
import { useVerification } from '../../../VerificationPopup/withVerification';
var EditButton = function (_a) {
    var disabled = _a.disabled, className = _a.className;
    var _b = useContext(CommentContext), comment = _b.comment, setEditingState = _b.setEditingState, isReduxReady = _b.isReduxReady;
    var restrictToVerified = useVerification().restrictToVerified;
    var onClickEdit = restrictToVerified('comment', function () {
        return setEditingState('editing');
    });
    var t = useTranslation().t;
    return (React.createElement(PlainButtonOrLink, { key: "edit-button", className: className, onClick: onClickEdit, "data-hook": BiDataHook.COMMENT_EDIT_BUTTON, biData: {
            evid: BiEventType.COMMENT_EDIT_CLICK,
            commentid: comment.commentId,
            typeid: comment.typeId,
            itemid: comment.itemId,
        }, disabled: disabled !== null && disabled !== void 0 ? disabled : !isReduxReady }, t('comment.action.edit')));
};
EditButton.displayName = 'EditButton';
export default EditButton;
//# sourceMappingURL=EditButton.js.map